import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

/**
 * The "⋯" options button on a post or comment: Edit, Delete, Pin (a group
 * owner, on a member's post) and Report (on someone else's content — never
 * your own). Shows nothing when none is allowed. The parent decides what
 * each choice does (delete/report should ask for confirmation/details first).
 */
@Component({
  selector: 'app-social-post-menu',
  templateUrl: './social-post-menu.component.html',
  styleUrls: ['./social-post-menu.component.scss'],
  standalone: false,
})
export class SocialPostMenuComponent {
  @Input() canEdit = false;
  @Input() canDelete = false;
  @Input() canPin = false;
  /** Whether the post is pinned right now (the menu then offers "Unpin"). */
  @Input() pinned = false;
  @Input() canReport = false;
  @Input() label = 'Post options';
  @Output() edit = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
  @Output() pin = new EventEmitter<void>();
  @Output() report = new EventEmitter<void>();

  open = false;

  constructor(private host: ElementRef<HTMLElement>) {}

  toggle(): void {
    this.open = !this.open;
  }

  choose(action: 'edit' | 'remove' | 'pin' | 'report'): void {
    this.open = false;
    if (action === 'edit') {
      this.edit.emit();
    } else if (action === 'pin') {
      this.pin.emit();
    } else if (action === 'report') {
      this.report.emit();
    } else {
      this.remove.emit();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.open && !this.host.nativeElement.contains(event.target as Node)) {
      this.open = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.open = false;
  }
}
